import { Container, Store, wrap } from 'AppReact';
import { InputWithButton, CustomDropdown } from 'containers';
import { InputError } from 'molecules';
import { AnnouncementText } from "./atoms";
import { AnnouncementWrapper } from "./wrappers";
import { IconFromUrl, SecondaryText3XlBold, SecondaryTextSm, SecondaryTextXs, SecondaryTextSm400, SecondaryText2xlBold } from "atoms";
import { ColumnWrapper, Mt4, Mt2, Mt5, Mt8, Mr2, Mr4, Width500, TextCenterWrapper, FullWidthJustifyEndWrapper, Px4, GenericWrapper, FlexBoxWrapper } from 'wrappers';
import getIsMobile from "components/atoms/utils/getIsMobile";

const isMobile = getIsMobile();

const options = [
  {
    id: 'en_us',
    display: 'English',
  },
  {
    id: 'es_419',
    display: 'Espanol',
  },
]

const definition = {
  name: "Header",
  props: { property: Store, selectedLanguage: Store, occupants: Store, isSavedApplication: Store },
  elements: [
    {
      wrapper: AnnouncementWrapper,
      name: "Section",
      renderIf: ({ property }) => !!property?.name && !property?.accepting_applications,
      elements: [
        {
          component: AnnouncementText,
          name: 'AnnouncementText',
          displayState: () => ({ textAlignment: 'center' }),
          displayValue: () => 'Unfortunately we are not accepting applications at this time.',
        },
      ]
    },
    {
      wrapper: ColumnWrapper,
      name: "Section",
      renderIf: ({ property }) => !!property?.name && property?.accepting_applications,
      elements: [
        {
          component: IconFromUrl,
          name: 'Logo',
          renderIf: ({ property }) => !!property?.logo,
          displayValue: ({ property }) => property?.logo ?? '',
          displayState: ({ }) => ({ width: isMobile ? '90px' : '184px', height: isMobile ? '90px' : '184px', borderRadius: '0px', objectFit: 'contain' })
        },
        {
          component: SecondaryText3XlBold,
          name: 'label',
          renderIf: ({ }) => !isMobile,
          displayValue: ({ }) => 'APPLICATION',
        },
        {
          component: SecondaryText2xlBold,
          name: 'label',
          renderIf: ({ }) => isMobile,
          displayValue: ({ }) => 'APPLICATION',
        },
        {
          wrapper: wrap(FlexBoxWrapper, Mt4),
          name: "FeeWrapper",
          elements: [
            {
              component: wrap(SecondaryTextSm, Mr2),
              name: 'ApplicationFee',
              renderIf: ({ property }) => property?.application_fee,
              displayValue: ({ property }) => `Application fee: $${property?.application_fee} `,
            }, {
              component: SecondaryTextSm,
              name: 'ApplicationAdditionalFee',
              renderIf: ({ property }) => property?.additional_applicant_fee,
              displayValue: ({ property }) => {
                if(property?.application_fee) {
                  return `(+$${property?.additional_applicant_fee} per additional applicant)`
                }

                return `+$${property?.additional_applicant_fee} per additional applicant`
              }             ,
            },
          ]
        },
        {
          component: wrap(SecondaryTextSm, Mt2),
          name: 'AdminFee',
          renderIf: ({ property }) => property?.application_admin_fee,
          displayValue: ({ property }) => `Admin fee: $${property?.application_admin_fee} per application*`,
        },
        {
          wrapper: isMobile ? Px4 : Width500,
          name: 'Wrapper',
          elements: [
            {
              component: wrap(CustomDropdown, Mt8),
              name: 'LanguageDropdown',
              bindings: ({ selectedLanguage }) => ({
                label: { values: ['Language:'], component: SecondaryTextXs },
                selectedOptionIds: selectedLanguage ? [selectedLanguage] : [],
                placeholder: 'Please Select Language',
                options,
              })
            },
            {
              component: wrap(InputWithButton, Mt5),
              name: 'Email',
              renderIf: ({ isSavedApplication }) => !isSavedApplication,
              bindings: ({ occupants }) => ({ occupants, disabledButton: !occupants[0].email, label: { values: ['Email:'] }, value: occupants[0].email || "", buttonText: 'Start Application', placeholder: 'example@gmail.com' }),
            },
            {
              component: InputError,
              name: 'EmailError',
              bindings: ({ occupants }) => ({ error: occupants[0].emailError }),
              renderIf: ({ occupants }) => !!occupants[0].emailError,
            },
            {
              component: wrap(wrap(SecondaryTextSm400, TextCenterWrapper), Mt8),
              name: 'EmailText',
              displayValue: ({ }) => 'You will receive an email with a link allowing you to continue your application at any time.'
            }
          ]
        },
      ]
    },
    {
      component: wrap(wrap(SecondaryTextSm, Mr4), FullWidthJustifyEndWrapper),
      name: 'AdminFee',
      renderIf: ({ property }) => property?.application_admin_fee,
      displayValue: ({ }) => '*Admin fee is payable later'
    }
  ],
};

export default Container(definition);
